import { useState, useEffect } from "react";
import useWindowDimensions from "./useWindowDimensions";

/**
 * Custom hook to determine if the current device is a mobile device
 * based on screen width.
 *
 * @param breakpoint - Optional breakpoint width to determine mobile devices (default: 768px)
 * @returns boolean - true if the device is considered mobile, false otherwise
 */
export default function useIsMobile(breakpoint: number = 768): boolean {
  const { width } = useWindowDimensions();
  const [isMobile, setIsMobile] = useState<boolean>(width <= breakpoint);

  useEffect(() => {
    setIsMobile(width <= breakpoint);
  }, [width, breakpoint]);

  return isMobile;
}
